module.exports = __webpack_public_path__ + "static/media/invitedFriends_50_75.abe9601e.png";